import { render, staticRenderFns } from "./media_catalog_edit.vue?vue&type=template&id=64456527&scoped=true"
import script from "./media_catalog_edit.vue?vue&type=script&lang=js"
export * from "./media_catalog_edit.vue?vue&type=script&lang=js"
import style0 from "./media_catalog_edit.vue?vue&type=style&index=0&id=64456527&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64456527",
  null
  
)

export default component.exports